<template>
    <Editor_CN v-model="content" :init="config" style="width:98%"></Editor_CN>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "editor_cn",
        data() {
            return {
				config: {
                    language: 'zh_CN',
                    plugins: 'autolink link image imagetools paste textcolor lists charmap print insertdatetime media emoticons table toc preview topic lineheight',
                    toolbar1: 'undo redo | bold italic lists | paste pastetext | fontsizeselect lineheightselect | indent outdent | alignleft aligncenter alignright alignjustify',
                    toolbar2: 'image removeformat | link unlink | forecolor | table | preview topic code',
                    // 字体
                    fontsize_formats: '12px 14px 16px 18px 20px 22px',
                    // font_formats:'Avenir',
                    // 行高
                    lineheight_formats: "10px 12px 14px 16px 18px 20px 22px 24px 26px 30px",
                    image_description: false,
                    paste_use_dialog : true,
                    paste_as_text: true,
                    paste_data_images: true,
                    paste_auto_cleanup_on_paste : true,
                    paste_convert_middot_lists : false,
                    // 自定义上传
                    images_upload_handler: (blobInfo, success, failure)=> {
                        this.uploads(blobInfo, success, failure)
                    },
                    // 选中图片点击编辑按钮触发
                    editkatex: (latex)=> {
                        // this.$emit('editLatex',latex)
                        // this.$store.commit('setLatex',latex)
                        this.$formula({
                            exper: latex,
                            onInsert: (url,expr)=> {
                                tinymce.activeEditor.insertContent(`<img src="${url}" data-latex="${expr}">`);
                            }
                        })
                    },
                    toFormula: ()=> {
                        // this.$emit('formula')
                        this.$formula({
                            exper: '',
                            onInsert: (url,expr)=> {
                                tinymce.activeEditor.insertContent(`<img src="${url}" data-latex="${expr}">`);
                            }
                        })
                    },
                    toFiles: ()=> {
                        // this.$emit('files')
                        this.$files((data) => {
                            data.forEach(item => {
                                if (item.type == 'image') {
                                    tinymce.activeEditor.insertContent(`<span style="padding:10px"><img src="${item.src}"/></span>`)
                                }
                                if (item.type == 'video') {
                                    tinymce.activeEditor.insertContent(
                                    `<span style="padding:10px"><video controls="controls" width="350" height="180"><source src="${item.src}" /></video></span>`)
                                }
                            });
                        })
                    },
                    // 选中图片出现选项
                    imagetools_toolbar: "rotateleft rotateright imageoptions",
                    // 上传路径
                    images_upload_url: this.uploadUrl,
                    // 自动上传图片
                    automatic_uploads: false,
                    height: this.height,
                    // 隐藏bar栏
					statusbar: false,
					skin: 'custom',
                    menubar: false,
                    // 是否行内
                    inline: this.inline?true:false
				}
            }
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            inline: {
                type: Boolean,
                default: false
            },
            uploadToken: {
                type: String,
                default: ''
            },
            uploadUrl: {
                type: String,
                default: ''
            },
            height: {
                type: Number,
                default: 400
            }
        },
        methods: {
            uploads(blobInfo, success, failure) {
                let formData = new FormData();
                formData.append('file', blobInfo.blob(), blobInfo.filename());
                formData.append('apiterminal','Aqt_20230517ApiWeb');
                axios.post(this.uploadUrl,formData,{
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': 'Bearer '+this.uploadToken
                    }
                }).then(res=> {
                    if(res.data.code==200) {
                        success(res.data.data.file_url);
                    } else {
                        failure(res.data.code+': '+res.data.message);
                    }

                }).catch(err=> {
                    console.log(err)
                    failure('fail: '+err);
                })
            }
        },
        computed: {
            content: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input',val)
                }
            }
        },
        components: {
            'Editor_CN': Editor
        },
    }
</script>
